import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import InquiriesPage from "../pages/inquiries/page";
import GalleryAdminPage from "../pages/admin/gallery/page";
import EquipmentAdminPage from "../pages/admin/equipment/page";
import InquiryAdminPage from "../pages/admin/inquiries/page";
import DashboardPage from "../pages/admin/dashboard/page";
import LoginPage from "../pages/auth/login/page";
import AuthGuard from "../components/AuthGuard";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/inquiries",
    element: <InquiriesPage />,
  },
  {
    path: "/auth/login",
    element: <LoginPage />,
  },
  {
    path: "/admin/dashboard",
    element: (
      <AuthGuard>
        <DashboardPage />
      </AuthGuard>
    ),
  },
  {
    path: "/admin/gallery",
    element: (
      <AuthGuard>
        <GalleryAdminPage />
      </AuthGuard>
    ),
  },
  {
    path: "/admin/equipment",
    element: (
      <AuthGuard>
        <EquipmentAdminPage />
      </AuthGuard>
    ),
  },
  {
    path: "/admin/inquiries",
    element: (
      <AuthGuard>
        <InquiryAdminPage />
      </AuthGuard>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;